import { Link } from "react-router-dom";
import { BrandLogo } from "../brand/BrandLogo";
import { SHOP_CATS, ABOUT_TABS } from "../../lib/site";
import { shopHref, aboutHref } from "./SiteNav";

const COLS = [
  ["SHOP", SHOP_CATS.map(([k, l]) => [k === "all" ? "All products" : l, shopHref(k)])],
  ["ABOUT", ABOUT_TABS.map(([k, l]) => [l, aboutHref(k)])],
  ["FOR ORGANISATIONS", [["Families", "/#groups"], ["Companies", "/#groups"], ["Schools", "/#groups"], ["Hospitals", "/#groups"], ["Sign in", "/sign-in"]]],
];

export default function SiteFooter() {
  return (
    <footer className="bg-[#0E1B33] text-white" data-testid="landing-footer" style={{ fontFamily: "Sora, sans-serif" }}>
      <div className="max-w-[1200px] mx-auto px-5 sm:px-8 py-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div><BrandLogo tone="dark" size={34} tagline testid="footer-logo" />
          <p className="mt-4 text-xs text-slate-400 max-w-[230px]">Emergency medical ID for East Africa. A product of <strong className="font-bold text-slate-300" data-testid="footer-company">MUGAWE INVESTMENTS U LTD</strong>.</p></div>
        {COLS.map(([h, links]) => <div key={h}><div className="text-[11px] font-extrabold tracking-[0.2em]">{h}</div>
          <div className="mt-3 space-y-2">{links.map(([l, href]) => href.startsWith("/#")
            ? <a key={l} href={href} className="block text-sm text-slate-300 hover:text-white transition-colors">{l}</a>
            : <Link key={l} to={href} className="block text-sm text-slate-300 hover:text-white transition-colors">{l}</Link>)}</div></div>)}
      </div>
      <div className="max-w-[1200px] mx-auto px-5 sm:px-8 py-5 border-t border-white/10 flex flex-wrap justify-between gap-3 text-xs text-slate-400">
        <span>© {new Date().getFullYear()} Mugawe Investments U Ltd · bsafe.today</span>
        <span className="space-x-1"><Link to="/" className="underline">Home</Link> · <Link to="/shop" className="underline">Shop</Link> · <Link to={aboutHref("security")} className="underline">Privacy</Link> · <a href="#" className="underline">Terms</a> · <a href="#" className="underline">Contact</a></span>
      </div>
    </footer>
  );
}
